define.alias("shared/components/shared/post/secondary/caption-writer/upgrade-button", "media/components/shared/post/secondary/caption-writer/upgrade-button");